import AuthLayout from "../../components/Auth/AuthLayout";
import AuthPageHelmet from "../../components/Auth/AuthPageHelmet";
import { AUTH_PAGE_DOCUMENT_TITLE_LOGIN } from "../../i18n/keysTranslations";
import LoginForm from "./components/LoginForm";
import { useSelectorApp } from "../../lib/redux";

const Login = () => {
  const { theme } = useSelectorApp((state) => state.ui);

  return (
    <AuthLayout>
      <AuthPageHelmet
        documentTitleKey={AUTH_PAGE_DOCUMENT_TITLE_LOGIN}
        nameBusiness={theme.nameBusiness}
      />
      <LoginForm />
    </AuthLayout>
  );
};

export default Login;
